/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// デフォルトで「通常購入」を選択
document.addEventListener('DOMContentLoaded', function() {
  // 複数のタイミングで試行
  const timings = [100, 300, 500, 1000]; // この数値を調整可能
  
  timings.forEach(function(delay) {
    setTimeout(function() {
      const onetimeRadio = document.getElementById('onetime');
      const subscriptionRadio = document.getElementById('subscription');
      
      if (onetimeRadio && subscriptionRadio) {
        // 定期購入が選択されている場合のみ変更
        if (subscriptionRadio.checked) {
          onetimeRadio.checked = true;
          subscriptionRadio.checked = false;
          
          // 複数の変更イベントを発火
          onetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
          onetimeRadio.dispatchEvent(new Event('click', { bubbles: true }));
          onetimeRadio.dispatchEvent(new Event('input', { bubbles: true }));
          
          console.log('通常購入に変更しました');
        }
      }
    }, delay);
  });
});